<template>
    <svg
    class="svgPlay"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
               width="18" height="20" viewBox="0 0 93 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    >  
<circle cx="46.5" cy="42.5" r="41.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M60.7929 41.7929L42.7071 23.7071C42.0771 23.0771 41 23.5233 41 24.4142V60.5858C41 61.4767 42.0771 61.9229 42.7071 61.2929L60.7929 43.2071C61.1834 42.8166 61.1834 42.1834 60.7929 41.7929Z" fill="black"/>
    </svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>
.svgPlay:hover path {
    fill:#EF2035;
    stroke:#EF2035;
    stroke-width:6;
}
.svgPlay:hover circle {
    stroke:#EF2035;
    stroke-width:6;
    cursor:pointer;
}
</style>